import React from 'react';
import { Code } from 'lucide-react';
import SectionsPage from '../components/common/SectionsPage';

const Languages: React.FC = () => {
  // Languages page doesn't have explicit sections, but we can group by category if needed
  // For now, all languages go into a default section
  const sections = {
    languages: {
      title: 'Programming Languages',
      description: 'Master popular programming languages with interview questions, MCQ tests, and practical examples',
      cardVariant: 'detailed' as const,
      gridCols: 3 as const,
      showProgress: false,
      showStats: true,
      hideHeader: true,
    },
  };

  return (
    <SectionsPage
      pageKey="languages"
      className="nav-tab-page languages-page"
      pageTitle="Programming Languages"
      pageDescription="Master popular programming languages with interview questions, MCQ tests, and practical examples"
      pageIcon={Code}
      iconColor="text-blue-600 dark:text-blue-400"
      gradientColors={{
        from: 'from-blue-500',
        via: 'via-primary-500',
        to: 'to-purple-500',
      }}
      sections={sections}
      defaultSection="languages"
      enableSearch={true}
      enableFilter={true}
      filterOptions={[
        { value: 'all', label: 'All Levels' },
        { value: 'beginner', label: 'Beginner' },
        { value: 'intermediate', label: 'Intermediate' },
        { value: 'advanced', label: 'Advanced' },
      ]}
    />
  );
};

export default Languages;
